import React from 'react';
import './PricingSection.css';
import { Link } from 'react-router-dom';

// PricingSection unified with other splash sections
export default function PricingSection(){
  return (
  <section id="pricing" className="snap-section m-pricing m-wrapper bg-pricing" aria-labelledby="m-pricing-h" data-section="pricing">
      <div className="m-pricing-wrap" role="group" aria-label="Pricing intro">
        <h2 id="m-pricing-h" className="m-pricing-h gradient-heading">
          <span className="pricing-plain">Join the</span>
          <span className="pricing-accent">Alpha</span>
        </h2>
        <p className="m-pricing-sub refined">Early access. Free while we're in Alpha.</p>
      </div>
      <div className="m-price-card enhanced" role="group" aria-label="Student Early Access free plan">
        <div className="m-price-lockup" aria-label="Zero dollars monthly plan">
          <span className="m-price-badge" aria-hidden>Student Early Access</span>
          <div className="m-price-main">
            <div className="m-price-amount animated" aria-label="Zero dollars per month">$0</div>
            <span className="m-price-period">/month</span>
            <span className="m-price-asterisk" aria-hidden>*</span>
          </div>
          <p className="m-price-desc">Free during Alpha. Keep your account; paid plans roll out later.</p>
        </div>
        <ul className="m-price-feats grid" aria-label="Included features">
          <li className="price-feat"><span className="feat-icon" aria-hidden>✅</span><span>Unlimited uploads</span></li>
          <li className="price-feat"><span className="feat-icon" aria-hidden>✅</span><span>Task dashboard</span></li>
          <li className="price-feat"><span className="feat-icon" aria-hidden>✅</span><span>Calendar sync</span></li>
          <li className="price-feat"><span className="feat-icon" aria-hidden>✅</span><span>AI doc chat</span></li>
        </ul>
        <p className="m-price-fine">No credit card required. Get set up in under a minute.</p>
        <Link
          to="/m/register"
          className="m-price-cta pricing-primary-btn"
          aria-label="Start free early access"
          data-cta="pricing-primary"
        >
          <span className="cta-emoji" aria-hidden>🚀</span>
          <span className="cta-label">Start Free</span>
        </Link>
        <p className="m-price-disclaimer" aria-hidden>*Discounts continue when paid plans launch. Cancel anytime.</p>
      </div>
    </section>
  );
}
